import * as React from 'react';
import { AddStroke16 } from '@cian/ui-kit';
import * as styles from './AddButton.css';
export function AddButton(_ref) {
  var text = _ref.text,
    showIcon = _ref.showIcon,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: styles['button'],
    onClick: onClick
  }, showIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['icon']
  }, /*#__PURE__*/React.createElement(AddStroke16, null)), /*#__PURE__*/React.createElement("span", null, text));
}